import { ActivityDuration } from '../../../../../../db/types';

export interface Props {
  onClose: () => void;
  onUpdateDuration: (activityDuration: ActivityDuration) => any;
}

const useDurationDialogVM = ({ onClose, onUpdateDuration }: Props) => {
  const onSelectionChange = (activityDuration: ActivityDuration) => {
    onUpdateDuration(activityDuration);
    onClose();
  };

  return { onSelectionChange };
};

export default useDurationDialogVM;
